import type { UndecoratedUser } from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import { isNullish } from '@witmetrics/utils/misc';
import { PersonIcon } from '@/icons';
import Chip from '@/components/Chip';
import TruncatedText from '@/components/TruncatedText';
import { classes } from './utils';

export type UserChipProps = {
  includeLastName?: boolean;
  useLastInitial?: boolean;
  className?: string;
  maxLength?: number;
  user: UndecoratedUser;
};

export default function UserChip({
  includeLastName = true,
  useLastInitial = false,
  className,
  maxLength,
  user,
}: UserChipProps) {
  const name = formatUserName(user, includeLastName, useLastInitial);
  return (
    <Chip className={className}>
      <>
        <PersonIcon className={classes.icon} />
        {isNullish(maxLength) ? (
          name
        ) : (
          <TruncatedText arrow tooltipPlacement="top" maxLength={maxLength}>
            {name}
          </TruncatedText>
        )}
      </>
    </Chip>
  );
}
